import {apiRequest} from './client';
import type {
    CreatePlanRequest,
    PlanStats,
    PlatformPlan,
    UpdatePlanRequest
} from '@/types/api';

export async function getPlans(): Promise<PlatformPlan[]> {
    return apiRequest<PlatformPlan[]>('/admin/plans', {
        method: 'GET'
    });
}

export async function getPlan(id: string): Promise<PlatformPlan> {
    return apiRequest<PlatformPlan>(`/admin/plans/${id}`, {
        method: 'GET'
    });
}

export async function createPlan(data: CreatePlanRequest): Promise<PlatformPlan> {
    return apiRequest<PlatformPlan>('/admin/plans', {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export async function updatePlan(id: string, data: UpdatePlanRequest): Promise<PlatformPlan> {
    return apiRequest<PlatformPlan>(`/admin/plans/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
}

export async function archivePlan(id: string): Promise<PlatformPlan> {
    return apiRequest<PlatformPlan>(`/admin/plans/${id}`, {
        method: 'DELETE'
    });
}

export async function setLimits(
    id: string,
    limits: Record<string, { value: number; error?: string }>
): Promise<void> {
    return apiRequest<void>(`/admin/plans/${id}/limits`, {
        method: 'PUT',
        body: JSON.stringify({limits})
    });
}

export async function setFeatures(
    id: string,
    features: Record<string, boolean>
): Promise<void> {
    return apiRequest<void>(`/admin/plans/${id}/features`, {
        method: 'PUT',
        body: JSON.stringify({features})
    });
}

export async function duplicatePlan(id: string, newSlug: string): Promise<PlatformPlan> {
    return apiRequest<PlatformPlan>(`/admin/plans/${id}/duplicate`, {
        method: 'POST',
        body: JSON.stringify({newSlug})
    });
}

export async function getPlanStats(): Promise<PlanStats[]> {
    return apiRequest<PlanStats[]>('/admin/plans/stats', {
        method: 'GET'
    });
}
